// extracted by mini-css-extract-plugin
export default {"cardsList":"EpicCardsList_cardsList__O-7Q0","cardsListTitle":"EpicCardsList_cardsListTitle__SPQ81"};